<tgrid-resiliency-chart-widget [type]="curveType.NORMALIZED_IMPACT"/>
<tgrid-resiliency-chart-widget [type]="curveType.RECOVERY_DURATION"/>
<tgrid-resiliency-overview-widget/>
